import { render, staticRenderFns } from "./serviceDataCreationComp.vue?vue&type=template&id=e9f89400&scoped=true"
import script from "./serviceDataCreationComp.vue?vue&type=script&lang=js"
export * from "./serviceDataCreationComp.vue?vue&type=script&lang=js"
import style0 from "./serviceDataCreationComp.vue?vue&type=style&index=0&id=e9f89400&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9f89400",
  null
  
)

export default component.exports